import { useApolloClient, useQuery } from '@apollo/react-hooks';

import { USER_CLUB_ID, APOLLO_USER_ID } from './local-state';
import { GET_USER_FRAGMENT } from './fragments/user-fragment';
import { BUSINESS_DETAIL_GQL } from './queries/business-page-query';
import { GET_SYSTEM_BUSINESS } from './queries/system-business';
import { BusinessGroup, PageInfo } from '../components/pages-login/business-groups/types';
import { BUSINESS_GROUPS_GQL } from './queries/business-groups-query';

export const useBusiness = () => {
  const {
    data: { userClubId },
  } = useQuery(USER_CLUB_ID);

  const { data }  = useQuery(BUSINESS_DETAIL_GQL, {
    variables: { businessId: userClubId },
    fetchPolicy: 'cache-and-network',
    skip: !userClubId,
  });

  const business = data?.business;

  return {
    ...business,
    timezone: business?.timezone || 'UTC',
    business_features: business?.business_features || {
      auditions: null,
      bookings: null,
      audition_limits: {
        applications_max: null,
        duration_max: null
      }
    }
  };
};

export const useUser = () => {
  const CLIENT = useApolloClient();
  const {
    data: { userId },
  } = useQuery(APOLLO_USER_ID);

  const USER = CLIENT.readFragment({
    id: `User:${userId}`,
    fragment: GET_USER_FRAGMENT,
  });

  return USER || {};
};

export const useHasPermission = (permission: string) => {
  const {
    data: { userClubId },
  } = useQuery(USER_CLUB_ID);
  const { admin, roles } = useUser();

  if (admin) return true;

  const PERMISSIONS = roles?.[userClubId]?.permissions ?? [];

  return PERMISSIONS.includes(permission);
};

export const useSystemBusiness = () => {
  const { admin } = useUser();

  const { data }  = useQuery(GET_SYSTEM_BUSINESS, {
    fetchPolicy: 'cache-and-network',
    skip: !admin,
  });

  return data?.system_business;
};

export const useBusinessGroups = () => {
  const { loading, error, data } = useQuery<{
    business_groups: { nodes: [BusinessGroup]; pageInfo: PageInfo; totalCount: number };
  }>(BUSINESS_GROUPS_GQL, {
    fetchPolicy: 'cache-and-network',
    variables: {
      sortOrder: 'ASC',
      orderBy: 'NAME'
    }
  });

  return {
    loading, error, data
  };
};
